import { Col, Drawer, Menu, Row, Input, Spin } from "antd";
import React, { useEffect, useState, useRef, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import logo from "../../assets/images/logo.webp";
// import { ReactComponent as AdminIcon } from "../../assets/headerimage/admin.svg";
// import { ReactComponent as CartIcon } from "../../assets/headerimage/cart.svg";

import { UserContext } from "../../context/UserContext"; // ✅ import context
import Container from "../../components/container/Container";
import { getFromLocalStorage } from "../../utils/helperFunctions";
import ChatTalk from "../../widgets/chatTalk/ChatTalk";
import HeaderCartPreview from "./HeaderCartPreview";
import "./header.css";
import "./headerTwo.css";
import bumberger from "../../assets/humbergertool.webp";
import {
  MessageOutlined,
  SearchOutlined,
  UserOutlined,
  CustomerServiceOutlined,
  ArrowRightOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import { apiUrl, blogUrl } from "../../config/config";
import DesignNowLink from "../../components/DesignNowLink";
const CartIcon = ({ width = 25, height = 25, color = "currentColor" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1834.06 1795.94"
      width={width}
      height={height}
      fill={color}
    >
      <g>
        <path
          fillRule="nonzero"
          d="M93.11 210.16c-34.46,0 -62.41,-27.95 -62.41,-62.41 0,-34.46 27.95,-62.41 62.41,-62.41l164.73 0c31.35,0 57.31,23.14 61.7,53.21l73.95 342.63 1341.98 0 14.65 1.98c33.33,8.07 53.85,41.75 45.78,75.08l-175.7 716.52c-4.6,30 -30.5,52.93 -61.7,52.93l-1059.5 0c-28.8,-0.07 -54.7,-20.17 -60.93,-49.46l-230.47 -1068.07 -114.49 0zm327.34 395.84l128.79 596.87 960.58 0 146.33 -596.87 -1235.7 0z"
        />
        <path
          fillRule="nonzero"
          d="M594.81 1390.24c44.22,0 84.56,18.04 113.43,46.91 29.01,29.01 46.98,69.13 46.98,113.43 0,44.09 -17.97,84.14 -46.98,113.15 -29.37,29.3 -69.56,47.27 -113.43,47.27 -44.3,0 -84.42,-17.97 -113.43,-46.98 -28.87,-28.87 -46.91,-69.2 -46.91,-113.43 0,-44.3 18.04,-84.49 46.91,-113.36 29.01,-29.01 69.13,-46.98 113.43,-46.98zm25.12 135.22c-6.37,-6.37 -15.35,-10.4 -25.12,-10.4 -9.77,0 -18.68,4.03 -25.12,10.47 -6.37,6.37 -10.4,15.28 -10.4,25.05 0,9.77 4.03,18.75 10.4,25.12 6.44,6.44 15.35,10.47 25.12,10.47 9.91,0 18.89,-3.96 25.12,-10.19 6.51,-6.51 10.47,-15.5 10.47,-25.41 0,-9.76 -4.03,-18.68 -10.47,-25.12z"
        />
        <path
          fillRule="nonzero"
          d="M1486.54 1390.24c44.3,0 84.42,17.97 113.43,46.98l4.25 4.74c26.46,28.52 42.74,66.87 42.74,108.62 0,44.02 -18.04,84.28 -47.13,113.29 -28.87,29.15 -68.99,47.13 -113.29,47.13 -44.3,0 -84.42,-17.97 -113.43,-46.98l-4.25 -4.74c-26.46,-28.59 -42.74,-66.94 -42.74,-108.69 0,-44.01 18.04,-84.2 47.13,-113.22 28.87,-29.15 68.99,-47.13 113.29,-47.13zm25.12 135.3c-6.44,-6.44 -15.36,-10.47 -25.12,-10.47 -9.76,0 -18.68,4.03 -25.12,10.47 -6.51,6.22 -10.48,15.14 -10.48,25.05 0,8.85 3.19,16.91 8.28 23l2.2 2.12c6.44,6.44 15.35,10.47 25.12,10.47 9.76,0 18.68,-4.04 25.12,-10.47 6.51,-6.23 10.47,-15.21 10.47,-25.12 0,-8.84 -3.19,-16.84 -8.28,-22.93l-2.19 -2.12z"
        />
      </g>
    </svg>
  );
};

const HeaderTwo = () => {
  const navigate = useNavigate();
  const userDropdownRef = useRef(null);
  const desktopAccountRef = useRef(null);
  const searchRef = useRef(null);
  const mobileSearchRef = useRef(null);
  const navBarRef = useRef(null);
  const navSentinelRef = useRef(null);
  const [isNavPinned, setIsNavPinned] = useState(false);
  const [navBarHeight, setNavBarHeight] = useState(0);

  // ✅ pull data from context
  const {
    userData,
    userDataseller,
    matchedSellerLogin,
    cartLength,
    handleLogout,
    loading,
  } = useContext(UserContext);

  const [open, setOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [categories, setCategories] = useState([]);
  const [brand, setBrand] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [searchOpen, setSearchOpen] = useState(false);
  const [current] = useState("/");
const [activeCategory, setActiveCategory] = useState(null);
const [tshirtData, setTshirtData] = useState(null);

const [products, setProducts] = useState([]);
const [searchCategories, setSearchCategories] = useState([]);
const [searchSubcategories, setSearchSubcategories] = useState([]);
const [searchLoading, setSearchLoading] = useState(false);
const [isSearchPanelOpen, setIsSearchPanelOpen] = useState(false);

  const name = getFromLocalStorage("Name");
const handleLogoutAndRedirect = () => {
  handleLogout();
  navigate("/login");
};

  // 🔹 Keep header-two-nav pinned to the top once it scrolls to the viewport edge.
  // (position: sticky alone can't do this: header-two-nav is the last child of
  // header-two-desktop, so its containing block ends exactly where it does,
  // leaving it no room to stay stuck once scrolled past.)
  useEffect(() => {
    const updateHeight = () => {
      if (navBarRef.current) setNavBarHeight(navBarRef.current.offsetHeight);
    };
    updateHeight();
    window.addEventListener("resize", updateHeight);
    return () => window.removeEventListener("resize", updateHeight);
  }, []);

  useEffect(() => {
    const sentinel = navSentinelRef.current;
    if (!sentinel) return;
    const observer = new IntersectionObserver(
      ([entry]) => setIsNavPinned(!entry.isIntersecting),
      { threshold: 0 }
    );
    observer.observe(sentinel);
    return () => observer.disconnect();
  }, []);

  // 🔹 Fetch brands
  useEffect(() => {
    fetch(`${apiUrl}/api/brand_canvas`)
      .then((response) => response.json())
      .then((data) => {
        if (Array.isArray(data) && Array.isArray(data[0])) {
          setBrand(data[0]);
        } else {
          setBrand([]);
        }
      })
      .catch((error) => console.error("Error fetching brands:", error));
  }, []);
  useEffect(() => {
  fetch(`${apiUrl}/api/categories-subcategories/8`)
    .then((res) => res.json())
    .then((data) => {
      if (Array.isArray(data) && data.length > 0) {
        setTshirtData({
          id: data[0].category.id,
          name: data[0].category.name,
          icon: data[0].category.icon_path,
          subcategories: data
        });
      }
    })
    .catch((err) => console.error("T-shirt API error:", err));
}, []);

  // 🔹 Fetch product sub-categories
useEffect(() => {
  fetch(`${apiUrl}/api/categories-subcategories`)
    .then((response) => response.json())
    .then((data) => {
      const categoryMap = {};
      data.forEach((subcategory) => {
        if (!subcategory.category || !subcategory.category.id) return;
        const categoryId = subcategory.category.id;
        if (!categoryMap[categoryId]) {
          categoryMap[categoryId] = {
            id: categoryId,
            name: subcategory.category.name,
            icon: subcategory.category.icon_path,
            subcategories: [],
          };
        }
        categoryMap[categoryId].subcategories.push(subcategory);
      });

      const finalCategories = Object.values(categoryMap);
      setCategories(finalCategories);

      // ✅ YAHAN ADD KARO (IMPORTANT)
      if (finalCategories.length > 0) {
        setActiveCategory(finalCategories[0]);
      }
    })
    .catch((error) => console.error("Error fetching subcategories:", error));
}, []);

  const toggleDropdown = () => {
    setIsDropdownOpen((prev) => !prev);
  };

const handleSearch = (value) => {
  setSearchText(value);

  if (!value.trim()) {
    setProducts([]);
    setSearchCategories([]);
    setSearchSubcategories([]);
    setSearchLoading(false);
    setIsSearchPanelOpen(false);
    return;
  }

  if (value.length > 2) {
    setIsSearchPanelOpen(true);
    setSearchLoading(true);

    fetch(`${apiUrl}/api/product_search?name=${value}`)
      .then((res) => res.json())
      .then((data) => {
        setProducts(data.data || []);
        setSearchResults(data.data || []);
        setSearchCategories(data.categories || []);
        setSearchSubcategories(data.sub_categories || []);
      })
      .catch((err) => {
        console.error("Search error:", err);
        setProducts([]);
        setSearchResults([]);
        setSearchCategories([]);
        setSearchSubcategories([]);
      })
      .finally(() => {
        setSearchLoading(false);
      });

  } else {
    setProducts([]);
    setSearchResults([]);
    setSearchCategories([]);
    setSearchSubcategories([]);
    setSearchLoading(false);
    setIsSearchPanelOpen(false);
  }
};

  // Build the category groups shown in the search dropdown. Categories can
  // come from the API's top-level `categories`, and/or be derived from each
  // subcategory's own embedded `.category` -- the API sometimes returns
  // categories: [] while `sub_categories` still carries full category info, so
  // without this the subcategories would never render (they're nested under a
  // category header, and there'd be no header to nest under).
  const searchCategoryGroups = React.useMemo(() => {
    const groups = new Map(); // category id -> { category, subs: [] }

    const ensureGroup = (cat) => {
      if (!cat || cat.id == null) return null;
      if (!groups.has(cat.id)) {
        groups.set(cat.id, { category: cat, subs: [] });
      }
      return groups.get(cat.id);
    };

    // Seed with any top-level categories first (preserves their order).
    searchCategories.forEach((cat) => ensureGroup(cat));

    // Attach each subcategory under its category, deriving the category from
    // the subcategory itself when the top-level list didn't include it.
    searchSubcategories.forEach((sub) => {
      const cat =
        sub.category ||
        searchCategories.find((c) => c.id === sub.category_id);
      const group = ensureGroup(cat);
      if (group) group.subs.push(sub);
    });

    return Array.from(groups.values());
  }, [searchCategories, searchSubcategories]);

  const handleProductClick = () => {
    setSearchResults([]);
    setProducts([]);
    setSearchCategories([]);
    setSearchSubcategories([]);
    setIsSearchPanelOpen(false);
    setSearchText("");
  };

  const handleSearchSubmit = () => {
    const value = searchText.trim();
    if (!value) return;

    setSearchResults([]);
    setIsSearchPanelOpen(false);
    setSearchOpen(false);
    navigate(`/catalogsearch/result/?q=${encodeURIComponent(value)}`);
  };

  const handleClearSearch = () => {
    setSearchText("");
    setSearchResults([]);
    setProducts([]);
    setSearchCategories([]);
    setSearchSubcategories([]);
    setIsSearchPanelOpen(false);
    setSearchLoading(false);
  };

  const getProductSearchImage = (product) => {
    const toFullImageUrl = (imagePath) => {
      if (!imagePath || typeof imagePath !== "string") return null;
      if (imagePath.startsWith("http")) return imagePath;
      if (imagePath.startsWith("/")) return `${apiUrl}${imagePath}`;
      return `${apiUrl}/${imagePath}`;
    };

    const parseImageMap = (imageMap) => {
      if (!imageMap) return null;
      if (typeof imageMap === "string") {
        try {
          return JSON.parse(imageMap);
        } catch {
          return null;
        }
      }
      return imageMap;
    };

    const findImageInMap = (imageMap) => {
      const parsedMap = parseImageMap(imageMap);
      if (!parsedMap || typeof parsedMap !== "object") return null;

      for (const colorImages of Object.values(parsedMap)) {
        if (typeof colorImages === "string") {
          return colorImages;
        }

        const imagePath =
          colorImages?.front ||
          colorImages?.style ||
          colorImages?.back ||
          colorImages?.side;

        if (imagePath) return imagePath;
      }

      return null;
    };

    const mappedImage =
      findImageInMap(product?.images) ||
      findImageInMap(product?.productImages2) ||
      findImageInMap(product?.thumbnail) ||
      findImageInMap(product?.subcat);

    if (mappedImage) return toFullImageUrl(mappedImage);

    const firstProductImage =
      typeof product?.productImages === "string"
        ? product.productImages.split(",")[0]?.trim()
        : null;

    return toFullImageUrl(firstProductImage);
  };

  const staticItems = [
    { 
      label: (
        <span className="menu-item-label">
          Products
        </span>
      ),
      key: "products" 
    },
    { 
      label: (
        <span className="menu-item-label">
          <a href={blogUrl}>Blogs</a>
        </span>
      ),
      key: "external-blog" 
    },
    {
      label: (
        <span className="menu-item-label">
          <DesignNowLink>DESIGN NOW</DesignNowLink>
        </span>
      ),
      key: "design-now",
      className: "design-now-btn-header",
    },
  ];

const categoryItems = [
  {
    key: "custom-mega-content",
    type: "group",
    label: (
      <div className="custom-mega-wrapper">

        {/* LEFT COLUMN — CATEGORIES WITH IMAGE */}
{/* LEFT COLUMN — CATEGORIES WITH IMAGE (CLICKABLE) */}
<div className="mega-col mega-col-1">
  <h4>Categories</h4>

  {categories.slice(0, 5).map((cat) => (
    <Link
      key={cat.id}
      to={`/products/${cat.name.replace(/\s+/g, "-")}/${cat.id}`}
      onClick={() => setSearchOpen(false)}
      className="mega-cat-link"
      onMouseEnter={() => setActiveCategory(cat)}
    >
      <div
        className={`mega-cat-row ${
          activeCategory?.id === cat.id ? "active-cat" : ""
        }`}
      >
        <img
          src={`${apiUrl}/storage/${cat.icon}`}
          alt={cat.name}
          className="mega-cat-thumb"
        />
        <p className="mega-cat-item">{cat.name}</p>
      </div>
    </Link>
  ))}

  <Link to="/products">
    <p className="mega-view-all">Browse All Categories →</p>
  </Link>
</div>


        {/* MIDDLE COLUMN — SUBCATEGORY LIST WITH IMAGE */}
        <div className="mega-col mega-col-2">
          <h4>{activeCategory?.name || "Subcategories"}</h4>

          {activeCategory ? (
            <>
              {activeCategory.subcategories.slice(0, 5).map((sub) => (
                <div
                  key={sub.id}
                  className="mega-sub-row"
                  onMouseEnter={() => setActiveCategory(activeCategory)}
                >
                  <img
                    src={`${apiUrl}/storage/${sub.icon_path}`}
                    alt={sub.name}
                    className="mega-sub-thumb"
                  />

                  <Link
                    to={`/products/${activeCategory.name.replace(/\s+/g, "-")}/${activeCategory.id}/${sub.name.replace(/\s+/g, "-")}/${sub.id}`}
                    className="mega-sub-item"
                  >
                    {sub.name}
                  </Link>
                </div>
              ))}

              <Link to={`/products/${activeCategory.name.replace(/\s+/g, "-")}/${activeCategory.id}`}>
                <p className="mega-view-all">View All {activeCategory.name} →</p>
              </Link>
            </>
          ) : (
            <p>Hover any category to preview subcategories</p>
          )}
        </div>

        {/* RIGHT COLUMN — PREVIEW CARDS */}
      <div className="mega-col mega-col-3">

  {activeCategory ? (
    activeCategory.subcategories.slice(0, 3).map((sub) => (
      <Link
        key={sub.id}
        to={`/products/${activeCategory.name.replace(/\s+/g, "-")}/${activeCategory.id}/${sub.name.replace(/\s+/g, "-")}/${sub.id}`}
        className="mega-preview-link"
      >
        <div className="mega-preview-card">
          <div className="mega-preview-img-wrapper">
            <img
              src={`${apiUrl}/storage/${sub.icon_path}`}
              alt={sub.name}
              className="mega-preview-thumb"
            />
          </div>

          <div className="mega-preview-info">
            <h5>{sub.name.toUpperCase()}</h5>

            <p>
              {sub.metatitle ||
                sub.metadescription ||
                "Explore premium styles and best sellers."}
            </p>

            <span className="mega-badge">Best Sellers</span>
          </div>
        </div>
      </Link>
    ))
  ) : (
    <p className="mega-empty-msg">Hover any category to preview items</p>
  )}

</div>


      </div>
    ),
  },
];



const tshirtItems = [
  {
    key: "tshirt-mega-content",
    type: "group",
    label: (
   <div className="tshirt-single-wrapper">

  <h4 className="tshirt-heading">
    {tshirtData?.name || "T-shirts"}
  </h4>

  <div className="tshirt-row-wrapper">
    {tshirtData?.subcategories.map((sub) => (
      <Link
        key={sub.id}
        to={`/products/${tshirtData.name.replace(/\s+/g, "-")}/${tshirtData.id}/${sub.name.replace(/\s+/g, "-")}/${sub.id}`}
        className="tshirt-row-item"
      >
        <img
          src={`${apiUrl}/storage/${sub.icon_path}`}
          alt={sub.name}
        />
        <span>{sub.name}</span>
      </Link>
    ))}
  </div>

</div>
    ),
  },
];






  const brandItems = brand.map((brandName, index) => ({
    label: (
      <Link
        to={`/products/brand/${brandName.replace(/\s+/g, "-")}`}
        onClick={(e) => e.stopPropagation()}
        style={{textTransform:'capitalize'}}
      >
        {brandName}
      </Link>
    ),
    key: `brand-${index}`,
    onClick: () =>
      navigate(`/products/brand/${brandName.replace(/\s+/g, "-")}`),
  }));


const mobileItems = [
  {
    label: "Custom T-shirts",
    key: "custom-tshirts",
    children: (tshirtData?.subcategories || []).map((sub) => ({
      key: `tshirt-sub-${sub.id}`,
      label: (
        <Link
          to={`/products/${tshirtData.name.replace(/\s+/g, "-")}/${tshirtData.id}/${sub.name.replace(/\s+/g, "-")}/${sub.id}`}
          onClick={() => setOpen(false)}
        >
          {sub.name}
        </Link>
      ),
    })),
  },

  {
    label: "Custom Apparel",
    key: "custom-apparel",
    children: categories.map((cat) => ({
      key: `cat-${cat.id}`,
      label: (
        <Link
          to={`/products/${cat.name.replace(/\s+/g, "-")}/${cat.id}`}
          onClick={() => setOpen(false)}
        >
          {cat.name}
        </Link>
      ),
      children: cat.subcategories.map((sub) => ({
        key: `sub-${sub.id}`,
        label: (
          <Link
            to={`/products/${cat.name.replace(/\s+/g, "-")}/${cat.id}/${sub.name.replace(
              /\s+/g,
              "-"
            )}/${sub.id}`}
            onClick={() => setOpen(false)}
          >
            {sub.name}
          </Link>
        ),
      })),
    })),
  },

{
  label: (
    <Link
      to="/products/brand"
      onClick={() => setOpen(false)}
      style={{ color: "inherit", textDecoration: "none" }}
    >
      Shop By Brands
    </Link>
  ),
  key: "brands",
  children: brand.map((b, i) => ({
    key: `brand-${i}`,
    label: (
      <Link
        to={`/products/brand/${b.replace(/\s+/g, "-")}`}
        onClick={() => setOpen(false)}
        style={{ textTransform: 'capitalize' }}
      >
        {b}
      </Link>
    ),
  })),
},

  {
    key: "products",
    label: (
      <Link to="/products" onClick={() => setOpen(false)}>
        Products
      </Link>
    ),
  },

  {
    key: "external-blog",
    label: (
      <a href={blogUrl} onClick={() => setOpen(false)}>
        Blogs
      </a>
    ),
  },

  // {
  //   key: "design-now",
  //   label: (
  //     <a
  //       href="https://inkox.com/designer?id=150&pid=5151&colorId=701426"
  //       onClick={() => setOpen(false)}
  //     >
  //       Design Now
  //     </a>
  //   ),
  // },

   {
      label: (
        <span className="menu-item-label">
          <DesignNowLink onClick={() => setOpen(false)}>
            Design Now
          </DesignNowLink>
        </span>
      ),
      key: "desktop-design-lab",
      className: "design-now-btn-headermob",
    },
];



  const items = [
    {
      label: (
        <span className="menu-item-label">
          Custom T-shirts
        </span>
      ),
      key: "custom-tshirts",
      children: tshirtItems,
      popupClassName: "brands-dropdown-wide",
    },
    
    {
      label: (
        <span className="menu-item-label">
          Custom Apparel
        </span>
      ),
      key: "custom-tshirt",
      children: categoryItems,
      popupClassName: "brands-dropdown-wide",
    },
    {
      label: (
        <span className="menu-item-label" onClick={() => navigate("/products/brand")}>
          Brands
        </span>
      ),
      key: "brands",
      children: brandItems,
      popupClassName: "brands-dropdown-wide brands-grid-4",
    },
    ...staticItems,
  ];

  const desktopItems = [
    {
      label: (
        <span className="menu-item-label">
          Custom T-shirts
        </span>
      ),
      key: "desktop-custom-tshirts",
      children: tshirtItems,
      popupClassName: "brands-dropdown-wide",
    },
    {
      label: (
        <span className="menu-item-label">
          Custom Apparel
        </span>
      ),
      key: "desktop-custom-apparel",
      children: categoryItems,
      popupClassName: "brands-dropdown-wide",
    },
  {
  label: (
    <span
      className="menu-item-label"
      onClick={() => { navigate("/products/brand"); setOpen(false); }}
    >
      Shop By Brands
    </span>
  ),
  key: "desktop-brands",
  children: brandItems,
  popupClassName: "brands-dropdown-wide brands-grid-4",
},
     {
      label: (
        <span className="menu-item-label">
          <Link to="/products">Products</Link>
        </span>
      ),
      key: "product",
    },
    {
      label: (
        <span className="menu-item-label">
          <a href={blogUrl}>Insights & Blog Posts</a>
        </span>
      ),
      key: "external-blog-desktop",
    },
      
    {
      label: (
        <span className="menu-item-label">
          <DesignNowLink onClick={() => setOpen(false)}>
            Design Now
          </DesignNowLink>
        </span>
      ),
      key: "desktop-design-lab",
      className: "design-now-btn-header",
    },
  ];

  useEffect(() => {
    const handleClickOutside = (event) => {
      const clickedMobileAccount =
        userDropdownRef.current &&
        userDropdownRef.current.contains(event.target);
      const clickedDesktopAccount =
        desktopAccountRef.current &&
        desktopAccountRef.current.contains(event.target);

      if (!clickedMobileAccount && !clickedDesktopAccount) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const onClick = (e) => {
    if (e.key === "logout") {
      handleLogout();
    } else if (e.key === "login") {
      navigate("/login");
    } else if (e.key === "design-now" || e.key === "desktop-design-lab") {
      setOpen(false);
    } else if (e.key === "external-blog" || e.key === "external-blog-desktop") {
      window.location.href = blogUrl;
    } else {
      navigate(`/${e.key}`);
    }
  };

  const handleSidebar = () => {
    setOpen(true);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      const clickedDesktopSearch =
        searchRef.current && searchRef.current.contains(event.target);
      const clickedMobileSearch =
        mobileSearchRef.current && mobileSearchRef.current.contains(event.target);

      if (!clickedDesktopSearch && !clickedMobileSearch) {
        setSearchResults([]);
        setIsSearchPanelOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const sellerAccountUrl = matchedSellerLogin
    ? "https://dashboard.inkox.com/auth/seller-login"
    : `https://dashboard.inkox.com/apps/ecommerce/seller-account?id=${userDataseller?.id}&name=${encodeURIComponent(
        userDataseller?.name || ""
      )}&pwd=${encodeURIComponent(userDataseller?.pwd || "")}&email=${encodeURIComponent(
        userDataseller?.email || ""
      )}&token=${encodeURIComponent(
        getFromLocalStorage("APP_TOKEN") || ""
      )}&role=seller&mode=register`;

  return (
    <header className="header header-two">
      <div className="container header-two-desktop">
        <div className="header-two-topline">
          <span>
            Custom T-shirts & Promotional Products, Fast & Free Shipping, and All-Inclusive Pricing
          </span>
          {userData?.email && userDataseller?.role === "seller" && (
            <a href={sellerAccountUrl} className="login-seller header-two-top-seller">
              <button type="button">Seller Account</button>
            </a>
          )}
        </div>

        <div className="header-two-main">
          <Link to="/" className="header-two-logo" aria-label="Inkofly home">
            <img src={logo} alt="Inkofly" />
          </Link>

          <div className="header-two-search" ref={searchRef}>
            <SearchOutlined className="header-two-search-icon" />
            <Input
              bordered={false}
              value={searchText}
              onChange={(e) => handleSearch(e.target.value)}
              onFocus={() => {
                if (searchText.trim().length > 2) {
                  setIsSearchPanelOpen(true);
                }
              }}
              onPressEnter={handleSearchSubmit}
              placeholder="Search for t-shirts, hoodies, koozies, and more"
            />
            {searchText && (
              <button
                type="button"
                className="header-two-search-clear"
                onClick={handleClearSearch}
                aria-label="Clear search"
              >
                <CloseOutlined />
              </button>
            )}
            <button
              type="button"
              className="header-two-search-submit"
              onClick={handleSearchSubmit}
              aria-label="Search"
            >
              <ArrowRightOutlined />
            </button>
            {searchLoading && isSearchPanelOpen && (
  <div className="header-two-search-results search-loader-panel">
    <div className="search-loader">
      <Spin size="small" />
      <span>Searching...</span>
    </div>
  </div>
)}

            {isSearchPanelOpen && searchText.trim().length > 2 && !searchLoading && (
  <div className="header-two-search-results">

    {/* 🔥 PRODUCTS */}
    {products.length > 0 && (
      <>
        <h4 className="search-heading">Products</h4>

        {products.map((product) => {
          const slug = product.name.replace(/\s+/g, "-").toLowerCase();

          const image = getProductSearchImage(product);

          return (
            <Link
              key={product.id}
              to={`/${slug}/${product.id}`}
              className="advanced-search"
              onClick={handleProductClick}
            >
              <div className="search-img">
                {image ? (
                  <img src={image} alt={product.name} />
                ) : (
                  <span className="search-img-placeholder">No Image</span>
                )}
              </div>
              <div className="search-info">
                <p>{product.name}</p>
              </div>
            </Link>
          );
        })}
      </>
    )}

    {/* 🔥 CATEGORIES */}
    {products.length === 0 && (
      <div className="search-section">
        <h4 className="search-heading">Products</h4>
        <p className="search-empty">No products found</p>
      </div>
    )}

    {searchCategoryGroups.length > 0 && (
      <>
        <h4 className="search-heading">Categories</h4>

        {searchCategoryGroups.map(({ category, subs }) => (
          <React.Fragment key={category.id}>
            {/* Only show the category header when it has no matching
                subcategories -- where subcategories show, we skip the parent
                category header (the subcategory keeps an "in {Category}"
                reference). */}
            {subs.length === 0 && (
              <Link
                to={`/products/${category.name.replace(/\s+/g, "-")}/${category.id}`}
                className="advanced-search"
                onClick={handleProductClick}
              >
                <div className="search-img">
                  <img src={`${apiUrl}/storage/${category.icon_path}`} alt="" />
                </div>
                <div className="search-info">
                  <p>{category.name}</p>
                </div>
              </Link>
            )}

            {subs.map((sub) => (
              <Link
                key={sub.id}
                to={`/products/${category.name.replace(/\s+/g, "-")}/${category.id}/${sub.name.replace(/\s+/g, "-")}/${sub.id}`}
                className="advanced-search"
                onClick={handleProductClick}
              >
                <div className="search-img">
                  <img src={`${apiUrl}/storage/${sub.icon_path}`} alt="" />
                </div>
                <div className="search-info">
                  <p>{sub.name}</p>
                  <span className="search-subcategory">in {category.name}</span>
                </div>
              </Link>
            ))}
          </React.Fragment>
        ))}
      </>
    )}

    {searchCategoryGroups.length === 0 && (
      <div className="search-section">
        <h4 className="search-heading">Categories</h4>
        <p className="search-empty">No categories found</p>
      </div>
    )}

    <button onClick={handleSearchSubmit}>View all results</button>
  </div>
)}
          </div>

          <div className="header-two-support">
            <CustomerServiceOutlined />
            <div>
              <span>Talk to a Real Person</span>
              <a href="tel:1232311234">123-321-1234</a>
            </div>
          </div>

          <div className="header-two-support">
            <MessageOutlined />
            <div>
              <span>Chat with a Real Person</span>
              <ChatTalk />
            </div>
          </div>
        </div>

        <div ref={navSentinelRef} />
        <div
          ref={navBarRef}
          className={`header-two-nav${isNavPinned ? " header-two-nav--pinned" : ""}`}
        >
          <Menu
            mode="horizontal"
            items={desktopItems}
            className="header-two-menusss"
            selectable={false}
          />

          <div className="header-two-actions">

            {!userData?.email ? (
              <Link to="/login" aria-label="Sign in">
                <UserOutlined />
                {/* <CartIcon width={40} height={40} /> */}
                <span>Sign In</span>
              </Link>
            ) : (
              <div className="header-two-account" ref={desktopAccountRef}>
                <button
                  type="button"
                  className="header-two-account-trigger"
                  onClick={toggleDropdown}
                  aria-expanded={isDropdownOpen}
                  aria-label="Account menu"
                >
                  <UserOutlined />
                  <span>Account</span>
                </button>

                {isDropdownOpen && (
                  <div className="header-two-account-menu">
                    <Link to="/accounts" onClick={() => setIsDropdownOpen(false)}>
                      My Account
                    </Link>
                    <button type="button" onClick={handleLogoutAndRedirect}>
                      Logout
                    </button>
                  </div>
                )}
              </div>
            )}
            <HeaderCartPreview cartLength={cartLength}>
              <CartIcon width={25} height={25} />
            </HeaderCartPreview>
          </div>
        </div>
        {isNavPinned && <div style={{ height: navBarHeight }} />}
      </div>

      <div className="header-two-mobile">
      <div className="" style={{ backgroundColor: "#f5f5f5",padding:"6px 0px" }}>
        <div
          className="container top-nav"
          style={{
            backgroundColor: "#f5f5f5",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div style={{ flex: 1 }} className="tagline">
            <span className="tagline">
              Custom T-shirts & Promotional Products, Fast & Free Shipping, and
              All-Inclusive Pricing
            </span>
          </div>

          <div style={{ display: "flex",width:"100%", justifyContent:"space-between", alignItems: "center", gap: "15px" }}>
            <span
              className="search-bar-container"
              style={{ position: "relative", marginLeft: "20px" }}
            >
              {/* <SearchOutlined
                className="mobile-search-icon"
                onClick={handleSearchToggle}
                style={{
                  fontSize: "20px",
                  cursor: "pointer",
                  padding: "8px",
                  border: "1px solid #d8d6d6",
                }}
              /> */}

                    <span className="">
            Fast & Free Shipping, and
              All-Inclusive Pricing
            </span>
              {loading && <Spin size="small" />}
            </span>

            {!userData?.email ? (
              <Link to="/login">
                <button
                  className="icon-headers icon-headersemail"
                  style={{
                    padding: "6px 0px",
                    backgroundColor: "transparent",
                    border: "none",
                    color: "#1f1f2b",
                    fontSize: "16px",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <UserOutlined style={{ fontSize: "22px", marginRight: "8px" }} />
                  Login
                </button>
              </Link>
            ) : (
              <div
                ref={userDropdownRef}
                style={{
                  display: "flex",
                  alignItems: "center",
                  position: "relative",
                }}
              >
                <span
                  style={{
                    marginRight: "0px",
                    fontSize: "12px",
                    cursor: "pointer",
                  }}
                  onClick={toggleDropdown}
                >
                  Welcome {name}
                </span>

                {isDropdownOpen && (
                  <div
                    className="main-login-signup"
                    style={{
                      position: "absolute",
                      top: "100%",
                      left: 0,
                      border: "1px solid #ccc",
                      padding: "10px",
                      backgroundColor: "#fff",
                      zIndex: 1000,
                      boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                      minWidth: "120px",
                    }}
                  >
                    {userData?.id && (
                      <>
                        <p>
                          <Link to="/accounts">My Account</Link>
                        </p>
                        <p>
                          <button
                            onClick={handleLogoutAndRedirect}
                            style={{
                              padding: "0px 0px",
                              border: "none",
                              background: "transparent",
                              color: "#1f1f2b",
                              fontSize: "17px",
                              cursor: "pointer",
                            }}
                          >
                            Logout
                          </button>
                        </p>
                      </>
                    )}
                  </div>
                )}
              </div>
            )}

            {/* <Link to="/policy" style={{ display: "contents" }}>
              <button
                className="icon-headers formobileonly"
                style={{
                  padding: "6px 0px",
                  backgroundColor: "transparent",
                  border: "none",
                  color: "#1f1f2b",
                  fontSize: "16px",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <CustomerServiceOutlined style={{ fontSize: "22px", marginRight: "8px" }} />
                Help
              </button>
            </Link> */}

            {userData?.email && userDataseller?.role === "seller" && (
              <a
                href={sellerAccountUrl}
                className="login-seller"
              >
                <button type="button">Seller Account</button>
              </a>
            )}
          </div>
        </div>
      </div>

      <Container className="container-header-main">
        <Row
          gutter={[40, 20]}
          justify={"space-between"}
          className="row-wesite-header"
          align={"middle"}
          style={{ flexFlow: "row", padding: "12px 0px" }}
        >
          <Col md={2} className="mobile-menu" style={{ textAlign: "right" }}>
            <img
              src={bumberger}
              alt="Menu"
              className="sideBarIcon"
              style={{ cursor: "pointer" }}
              onClick={handleSidebar}
            />
          </Col>

          <Col xs={10} sm={12} md={12} lg={12} xl={4} className="logo-colomn-mobile">
            <Link to={"/"} className="brand-logo">
              <img src={logo} alt="logo" />
            </Link>
          </Col>
              <Col xs={12} sm={10} md={10} lg={10} xl={0} className="">
                    <div style={{ display: "flex", justifyContent:"right", alignItems: "center", gap: "11px" }}>
                       <Link to="/policy" style={{ display: "contents" }}>
              <button
                className="icon-headers formobileonly"
                style={{
                  padding: "6px 0px",
                  backgroundColor: "transparent",
                  border: "none",
                  color: "#1f1f2b",
                  fontSize: "16px",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <CustomerServiceOutlined style={{ fontSize: "21px", marginRight: "4px" }} />
                Help
              </button>
            </Link>
                    <Link to="/cart" className="header-two-mobile-cart-link header-two-mobile-cart-link-compact" aria-label="Cart">
                      <span className="header-two-mobile-cart-icon">
                        <CartIcon width={25} height={25} />
                        {cartLength > 0 && <span className="header-two-cart-count">{cartLength}</span>}
                      </span>
                    </Link>
                    
                    {/* <div id="google_translate_element"></div> */}
          
                    {/* If no userData, show the login button */}
                    {!userData?.email ? (
                      <Link to="/login">
                        <button className="icon-headerstwo"
                          style={{
                            padding: "6px 0px",
                            backgroundColor: "",
                            border: "none",
                            color: "#1f1f2b",
                            fontSize: "12px",
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <UserOutlined style={{ fontSize: "21px", marginRight: "0px" }} />
                          
                        </button>
                      </Link>
                    ) : (
                      <div style={{ display: "flex", alignItems: "center" }} className="header-hide-website">
                        {/* Display user's email */}
                        <span style={{ marginRight: "15px", fontSize: "12px" }}>
                          {userData.email}
                        </span>
                        <button
                          onClick={handleLogout}
                          style={{
                            padding: "0px 0px",
                            backgroundColor: "",
                            border: "none",
                            color: "#1f1f2b",
                            fontSize: "17px",
                            cursor: "pointer",
                          }}
                        >
                          Logout
                        </button>
                      </div>
                    )}
                  </div>
                  
                    </Col>

          <Col md={14} className="desktop-menu desktopmenu-two">
                   <Menu
                     onClick={onClick}
                     selectedKeys={[current]}
                     mode="horizontal"
                     items={items}
                   />
                 </Col>

          <Col md={6} className="desktop-menu">
            <ChatTalk />
            
          </Col>
        </Row>
        <Row className="mobile-search-row" style={{ marginTop: "0px",marginBottom:"0px" }} justify="center" align="middle">
  <Col xs={24} sm={24} md={0}>
 <div className="header-two-search header-two-mobile-search" ref={mobileSearchRef} style={{ margin: '10px 0px' }}>
  <SearchOutlined className="header-two-search-icon" />
  <Input
    bordered={false}
    placeholder="Search for t-shirts, hoodies, koozies, and more"
    value={searchText}
    onChange={(e) => handleSearch(e.target.value)}
    onFocus={() => {
      if (searchText.trim().length > 2) {
        setIsSearchPanelOpen(true);
      }
    }}
    onPressEnter={handleSearchSubmit}
  />
  {searchText && (
    <button
      type="button"
      className="header-two-search-clear"
      onClick={handleClearSearch}
      aria-label="Clear search"
    >
      <CloseOutlined />
    </button>
  )}
  <button
    type="button"
    className="header-two-search-submit"
    onClick={handleSearchSubmit}
    aria-label="Search"
  >
    <ArrowRightOutlined />
  </button>
  {searchLoading && isSearchPanelOpen && (
    <div className="header-two-search-results search-loader-panel">
      <div className="search-loader">
        <Spin size="small" />
        <span>Searching...</span>
      </div>
    </div>
  )}

  {isSearchPanelOpen && searchText.trim().length > 2 && !searchLoading && (
    <div className="header-two-search-results">
      <div className="search-section">
        <h4 className="search-heading">Products</h4>
        {products.length > 0 ? (
          products.map((product) => {
            const slug = product.name.replace(/\s+/g, "-").toLowerCase();
            const image = getProductSearchImage(product);

            return (
              <Link
                key={product.id}
                to={`/${slug}/${product.id}`}
                className="advanced-search"
                onClick={handleProductClick}
              >
                <div className="search-img">
                  {image ? (
                    <img src={image} alt={product.name} />
                  ) : (
                    <span className="search-img-placeholder">No Image</span>
                  )}
                </div>
                <div className="search-info">
                  <p>{product.name}</p>
                </div>
              </Link>
            );
          })
        ) : (
          <p className="search-empty">No products found</p>
        )}
      </div>

      <div className="search-section">
        <h4 className="search-heading">Categories</h4>
        {searchCategoryGroups.length > 0 ? (
          searchCategoryGroups.map(({ category, subs }) => (
            <React.Fragment key={category.id}>
              {/* Only show the category header when it has no matching
                  subcategories -- where subcategories show, skip the parent
                  category header (subcategory keeps an "in {Category}" ref). */}
              {subs.length === 0 && (
                <Link
                  to={`/products/${category.name.replace(/\s+/g, "-")}/${category.id}`}
                  className="advanced-search"
                  onClick={handleProductClick}
                >
                  <div className="search-img">
                    <img src={`${apiUrl}/storage/${category.icon_path}`} alt={category.name} />
                  </div>
                  <div className="search-info">
                    <p>{category.name}</p>
                  </div>
                </Link>
              )}

              {subs.map((sub) => (
                <Link
                  key={sub.id}
                  to={`/products/${category.name.replace(/\s+/g, "-")}/${category.id}/${sub.name.replace(/\s+/g, "-")}/${sub.id}`}
                  className="advanced-search"
                  onClick={handleProductClick}
                >
                  <div className="search-img">
                    <img src={`${apiUrl}/storage/${sub.icon_path}`} alt={sub.name} />
                  </div>
                  <div className="search-info">
                    <p>{sub.name}</p>
                    <span className="search-subcategory">in {category.name}</span>
                  </div>
                </Link>
              ))}
            </React.Fragment>
          ))
        ) : (
          <p className="search-empty">No categories found</p>
        )}
      </div>

      <button onClick={handleSearchSubmit}>View all results</button>
      
    </div>
  )}
</div>
  </Col>
</Row>
      </Container>
      <Drawer
  placement="left"
  onClose={() => setOpen(false)}
  open={open}
  className="header-sidebar"
>
  <Menu
    selectedKeys={[current]}
    mode="inline"
    items={mobileItems}
  />
</Drawer>
<Drawer
  placement="right"
  onClose={() => setSearchOpen(false)}
  open={searchOpen}
  className="search-sidebar"
>
  <div className="search-results-container">
    <Input
      placeholder="Search for products"
      prefix={<SearchOutlined />}
      value={searchText}
      onChange={(e) => handleSearch(e.target.value)}
      onPressEnter={handleSearchSubmit}
      style={{ width: "100%", padding: "10px", borderRadius: "5px", marginBottom: "10px" }}
    />

    {searchLoading ? (
      <p style={{ textAlign: "center", color: "#666" }}>Loading products...</p>
    ) : searchResults.length > 0 ? (
      searchResults.map((product) => {
        const image = getProductSearchImage(product);
// 🔹 Get first subcategory
const sub = product.sub_category2?.[0];

// 🔹 Get category from first subcategory
const cat = sub?.category;

// 🔹 Build slug
const productSlug = product.name.replace(/\s+/g, "-").toLowerCase();

// 🔹 Build full required URL
const productUrl = cat && sub
  ? `/products/${cat.name.replace(/\s+/g, "-")}/${cat.id}/${sub.name.replace(/\s+/g, "-")}/${sub.id}/${productSlug}/${product.id}`
  : `/${productSlug}/${product.id}`;

        return (
          <div className="image-preview-searchbar-main" key={product.id}>
            <div className="image-preview-searchbar">
              <Link
                to={productUrl}
                className="search-result-item"
                onClick={() => {
                  handleProductClick();
                  setSearchOpen(false);
                }}
              >
                {image ? (
                  <img
                    src={image}
                    alt={product.name}
                    className="search-product-image"
                  />
                ) : (
                  <p style={{ textAlign: "center", color: "#666" }}>No image available</p>
                )}
                <div className="search-product-info">
                  <span className="search-product-name">{product.name}</span>
                </div>
              </Link>
            </div>
          </div>
        );
      })
    ) : (
      <p style={{ textAlign: "center", color: "#666" }}>No matching product found</p>
    )}
  </div>
  
</Drawer>


      </div>
    </header>
  );
};

export default HeaderTwo;
